//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ConfirmButton',
  data() {
    return {
      popoverVisible: false,
    };
  },
  methods: {
    confirm() {
      this.popoverVisible = false;
      this.$emit('confirm');
    },
  },
};
